import { FC, SVGProps } from "react";

const MetaculusMarkBoxed: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M58 0V58H0V0H58ZM4 54H54V4H4V54Z" fill="currentColor" />
    <path
      d="M23.4068 23.6402V42H19V16H25.2147L28.9435 28.9415L32.6723 16H39V42H34.4802V23.6402L30.0734 42H27.8136L23.4068 23.6402Z"
      fill="currentColor"
    />
  </svg>
);

export default MetaculusMarkBoxed;
